import Image from 'next/image'
import { type ReactNode } from 'react'

interface AddStoryCardProps {
  className?: string
  image: string
  text: string
  AddStoryDialog?: ReactNode
}

export default function AddStoryCard({
  className = '',
  image,
  text,
  AddStoryDialog,
}: AddStoryCardProps) {
  return (
    <div
      className={`flex flex-col justify-center gap-2 p-4 text-center ${className}`}
    >
      <div className="p-1">
        <Image
          className="m-auto h-16 w-16"
          src={image}
          alt="Post-it Zeichnung"
        />
      </div>
      <p className="text-text-secondary text-sm">{text}</p>
      <div>{AddStoryDialog}</div>
    </div>
  )
}
